var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$classes['content-loading'],style:(_vm.loadingStyle)},[_c('loading',{class:_vm.$classes['loading'],style:(_vm.loadingSizeStyle)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }